import { TSurfaces } from './types';

export const surfacesTypes: TSurfaces = [
  {
    name: 'wall',
    label: 'Стены',
    materialLabel: 'Материал стен',
  },
  {
    name: 'floor',
    label: 'Пол',
    materialLabel: 'Материал пола',
  },
  {
    name: 'ceiling',
    label: 'Потолок',
    materialLabel: 'Материал потолка',
  },
];
